module.exports = __webpack_public_path__ + "static/media/home_bg.21cbe5f0.png";